import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Quote } from 'lucide-react';
export function ProofSection() {
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-134">
      <div className="max-w-3xl mx-auto" data-id="element-135">
        <FadeIn data-id="element-136">
          <div className="relative bg-brand-cream p-8 md:p-12 rounded-2xl" data-id="element-137">
            <Quote className="absolute top-6 left-6 w-12 h-12 text-brand-amber opacity-20" data-id="element-138" />
            <p className="text-xl md:text-2xl leading-relaxed italic text-brand-brown relative z-10" data-id="element-139">
              "Un padre de Madrid pasó de tener un hijo que no se quitaba los
              cascos en todo el fin de semana a compartir cenas de una hora
              donde el niño, por iniciativa propia, empezó a contarle sus
              problemas en el instituto. Todo cambió al dejar de preguntar y
              empezar a 'conectar' mediante el ritual de los 10 minutos."
            </p>
            <div className="mt-8 flex items-center gap-4" data-id="element-140">
              <div className="w-12 h-12 bg-brand-brown rounded-full flex items-center justify-center text-brand-cream font-bold font-serif text-xl" data-id="element-141">
                C
              </div>
              <div data-id="element-142">
                <p className="font-bold text-brand-brown" data-id="element-143">Carlos M.</p>
                <p className="text-sm text-brand-gray/80" data-id="element-144">
                  Padre de un adolescente de 15 años
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}